<script>
	import { Alert, Icon, FormGroup, Input } from '@sveltestrap/sveltestrap';
	import { appClinicalPoliciesState } from "../../state/ApplicationState.svelte";	
    import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
	import { baseUrl } from "../../../../../SharedSvelte/Common.svelte";	

    let formData = $state({
		searchTerm: ""
	});	

    async function searchClinicalPolicies() {       
		
        Loader.display();

        try {
			var sendFormData = JSON.parse(JSON.stringify(formData.searchTerm));						   						

             const response = await fetch(`${baseUrl}Options/ClinicalPolicies/SearchClinicalPolicies`, {
				    method: "POST",
				    headers: {
					    "Content-Type": "application/json",
					    __RequestVerificationToken: document.getElementsByName("__RequestVerificationToken")[0].value,
				    },
				    body: JSON.stringify(sendFormData),
			    });
			    if (!response.ok) {
				    const error = `Server exception: ${response.status} ${response.statusText}`;
				    console.log(error);
				    throw new Error();
			    }

			    const json = await response.json();
			    if (!json.success) {
				    console.log(json.errors);
				    throw new Error(json.errors);
			    }
				
			appClinicalPoliciesState.clinicalPolicies = json.clinicalPolicies;			            			
        }
        catch (err) {           
            console.log("error searching", err)          
        }
        finally {
            Loader.hide();
        }       
    }

    function clearSearchTerm(event) {
		event.preventDefault();
        formData.searchTerm = "";	
		searchClinicalPolicies();
        window.scrollTo(0, 0);
	}

	function searchPolicies(event) {		
		event.preventDefault();
		searchClinicalPolicies();
		window.scrollTo(0, 0);
	}
	
	function handleDownloadClinicalPolicy(event){
		event.preventDefault();
		var entryId = event.currentTarget.dataset.entryid;
		var entryName = event.currentTarget.dataset.entryname;
		var downloadUrl = baseUrl + "Options/ClinicalPolicies/DownloadPolicy";
		const url = downloadUrl + "?entryId=" + encodeURIComponent(entryId) + "&entryName=" + entryName;
		window.open(url, "_blank", "noopener,noreferrer");
	}
</script>

<main>	
	 <Alert color="secondary">
		<p><Icon name="info-circle-fill" /> PEHP requires that preauthorization be obtained before specific procedures are covered and eligible for reimbursement for our members.</p>
        <span><a href="https://www.pehp.org/providers/care-management-and-wellness/medical-preauthorization" target="_blank">View services that require preauthorization.</a></span>
     </Alert>

	<span class="mt-5 fw-semibold">Enter a word or phrase to search for Clinical Policies that mention it.</span>
	<div class="row">
		<div class="col-md-6">
			<FormGroup floating spacing="mb-3" label="Search for..." class="d-flex gap-2 my-2">
				<Input
					placeholder="Search for..."
					type="text"
					bind:value={formData.searchTerm}			
				/>
				<button class="btn btn-lg btn-primary" disabled={!formData.searchTerm.trim()} onclick={searchPolicies}>Search</button>				
				<button class="btn btn-lg btn-light" onclick={clearSearchTerm}>Clear</button>							
			</FormGroup>
		</div>
	</div>
	{#if appClinicalPoliciesState.clinicalPolicies && appClinicalPoliciesState.clinicalPolicies.length > 0}
        <table class="table table-hover table-bordered table-striped mb-4">
            <thead>
                <tr class="table-primary fw-bold">
                    <td>Policy Name</td>      					
                </tr>
            </thead>
            <tbody>             
                {#each appClinicalPoliciesState.clinicalPolicies as policy}
                    <tr>  
						<!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_static_element_interactions, a11y_missing_attribute -->
						<td><a data-entryid="{policy.id}" data-entryname="{policy.name}" onclick={handleDownloadClinicalPolicy} aria-label="Download" class="hover-hand"><Icon name="pdf" /> {policy.name}</a></td>		             									
                    </tr>
                {/each}
            </tbody>
        </table>
	{:else}
		<div class="ms-3 mt-2">
			<h4 >No clinical policies found</h4>
		</div>		
	{/if}
</main>